import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
import { GlobalContext } from "../Context/GlobalState";
import Loader from "../assets/images/loader.gif"

const toastStyles = {
  position: "fixed",
  top: "20px",
  right: "20px",
  backgroundColor: "#333",
  color: "white",
  padding: "10px 20px",
  borderRadius: "5px",
  zIndex: 9999,
  boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
  opacity: 0.9,
  minWidth: "200px",
  textAlign: "center",
};

const Toast = ({ message, type = "info", onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const bgColor =
    type === "success"
      ? "#28a745"
      : type === "error"
      ? "#dc3545"
      : type === "warning"
      ? "#ffc107"
      : "#333";

  return <div style={{ ...toastStyles, backgroundColor: bgColor }}>{message}</div>;
};

const LoginHandler = () => {
  const { setUserInfo, setUserParent } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [toast, setToast] = useState(null);
  const [devToolsOpen, setDevToolsOpen] = useState(false);
  useEffect(() => {
    const threshold = 160;

    const detectDevTools = () => {
      if (
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold
      ) {
        setDevToolsOpen(true);
      }
    };

    detectDevTools();
    window.addEventListener("resize", detectDevTools);
    const interval = setInterval(detectDevTools, 200);

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", detectDevTools);
    };
  }, []);

  useEffect(() => {
    const disableKeys = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && e.key === "I") ||
        (e.ctrlKey && e.shiftKey && e.key === "J") ||
        (e.ctrlKey && e.key === "U")
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", disableKeys);
    document.addEventListener("contextmenu", (e) => e.preventDefault());

    return () => {
      document.removeEventListener("keydown", disableKeys);
    };
  }, []);
  useEffect(() => {
    if (devToolsOpen) return; // 🚫 Don't proceed if blocked

    const queryParameters = new URLSearchParams(window.location.search);
    const tokenid1 = queryParameters.get("accessToken");

    const callbackUrl = encodeURIComponent(
      window.location.origin + window.location.pathname
    );

    const loginUrl = `https://accounts.seobix.com/?callback=${callbackUrl}&product_id=2`;

    if (!tokenid1) {
      window.location.href = loginUrl;
    } else {
      Getssologin(tokenid1);
    }
  }, [devToolsOpen]);

  const Getssologin = async (tokenid1) => {
    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/BillPunchSSOLoginV1`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token: tokenid1, product: "BillPunch" }),
          mode: "cors",
        }
      );

      const data = await res.json();

      if (data.responseCode === "00") {
        setToast({ message: data.responseMessage, type: "success" });
        setUserInfo(data.response);
        setUserParent(data.profiledetails.data[0]);
        setTimeout(() => {
          const userType = data.response.us_type;
        
          if (userType === "A") {
            navigate("/admin/AdminDashboard");
          } else if (userType === "H") {
            navigate("/Hr/HRDashboard");
          } else if (userType === "E") {
            navigate("/Employee/dashboard");
          } else if (userType === "S") {
            navigate("/superadmin/dashboard");
          } else {
            navigate("/"); // fallback
          }
        }, 1500);
      } else {
        setToast({ message: data.responseMessage || "Login failed", type: "error" });
      }
    } catch (error) {
      setToast({ message: "Login API error: " + error.message, type: "error" });
    }
  };
  if (devToolsOpen) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          background: "#000",
          color: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "24px",
          fontWeight: "bold",
        }}
      >
        Developer Tools Detected. Access Blocked.
      </div>
    );
  }
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <img src={Loader} alt="Loading..." style={{ width: "", height: "" }} />
  
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
          duration={3000}
        />
      )}
    </div>
  );
  
};

export default LoginHandler;
